import { render, staticRenderFns } from "./ElectronicExternalDocument.vue?vue&type=template&id=5796c41f&"
import script from "./ElectronicExternalDocument.vue?vue&type=script&lang=js&"
export * from "./ElectronicExternalDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports